import { toZonedTime } from "date-fns-tz";
import { asDate } from "../date-time/as-date";
import type { WeekdayShortName } from "../parse-weekly-schedule";
import { generateFullDayDailySchedule } from "./generate-full-day-daily-schedule";
import { isWithinScheduleException } from "./is-within-schedule-exception";
import type { WeeklySchedule } from "./weekly-schedule";
import type { WeeklyScheduleException } from "./weekly-schedule-exception";

const formatter = Intl.DateTimeFormat("en-GB", { weekday: "short" });

const getDailySchedulesForWeekday = (
    day: Date | WeekdayShortName,
    defaultWeeklySchedule: WeeklySchedule,
    exceptions: WeeklyScheduleException[],
) => {
    const exception =
        typeof day !== "string"
            ? exceptions.filter(e =>
                  isWithinScheduleException(
                      day,
                      toZonedTime(asDate(e.start), "Europe/Stockholm"),
                      toZonedTime(asDate(e.end), "Europe/Stockholm"),
                  ),
              )
            : [];

    const weeklySchedule =
        exception.length > 0 ? exception[0].hours : defaultWeeklySchedule;

    const shortNameOfDay =
        typeof day === "string"
            ? day
            : (formatter.format(day).toLocaleLowerCase() as WeekdayShortName);
    const todaysBusinessHours = weeklySchedule[shortNameOfDay];
    const dailySchedules =
        typeof todaysBusinessHours === "boolean"
            ? todaysBusinessHours
                ? [generateFullDayDailySchedule()]
                : []
            : todaysBusinessHours;

    return dailySchedules;
};

export { getDailySchedulesForWeekday };
